module.exports = __webpack_public_path__ + "img/button-back.b11a4eca.svg";